import soon from '../../assests/home-page/soon.png'

const Soon = ({ top, font, position, bottom, height, width, borderRadius }) => {
    return (
        <div 
            style={{
                backgroundImage:  `url(${soon}`,
                top: `${top}`, position: `${position}`, bottom: `${bottom}`,
                height: `${height}`, width: `${width}`, borderRadius: `${borderRadius}`
            }}>

        </div>
    )

}
export default Soon
